import { General_Interface } from "./General_Interface"

export interface Kartable_Order_Interface {
  id:number,
  id2:number,
  calibration_id:number,
  calibration_detail_id:number,
  inlocation:boolean,
  Processing:boolean,
  expert_name:String,
  devicename:String,
  tariff_dsc:String,
  customer_id:number,
  customer:String,
  customer_code:String,
  recieveCode:String,
  tarikhTahvi:String,
  expertSubmitDate:String,
  status:String,
  price:String,
  src:String,
  code:String,
  code2:String,
  serial:String,
  filename:String,
  certificate: String,
  username_img: String,
  flowchartRequestDsc: String,
  typeItem:number,
  hasRequestToExit:number,
  certificate_user_code: String,
  expert_submit_date_visible: boolean,
  controller : Array<General_Interface>
}

export function Empty_Kartable_Order_Interface():Kartable_Order_Interface{
  return{
    id:0,
    id2:0,
    calibration_id:0,
    calibration_detail_id:0,
    inlocation:false,
    Processing:false,
    expert_name:'',
    devicename:'',
    tariff_dsc:'',
    customer_id:0,
    customer:'',
    customer_code:'',
    recieveCode:'',
    tarikhTahvi:'',
    expertSubmitDate:'',
    status:'',
    price:'',
    src:'',
    code:'',
    flowchartRequestDsc:'',
    username_img:'',
    code2:'',
    serial:'',
    filename:'',
    certificate: '',
    typeItem:0,
    hasRequestToExit:0,
    certificate_user_code: '',
    expert_submit_date_visible: false,
    controller:[]
  }
}
